<template>
    <div class="grid grid-cols-6 align-middle material-select" :class="{active: active}" @click="onClick">
        <div class="image cursor-pointer">
            <img :src="image" :alt="title">
        </div>
        <div class="col-span-5 flex flex-col justify-center">
            <div class="pl-4">
                <!-- <div><span class="font-semibold">{{ title }}</span>, <span class="font-italic">ab {{ moneyFormat(price) }}</span></div> -->
                <div><span class="font-semibold">{{ title }}</span></div>
                <!-- <div class="font-italic">{{ subtitle }}</div> -->
            </div>
        </div>
    </div>
</template>

<script>
import { moneyFormat } from "~/scripts/Pipeline/_helpers.js";

export default {
    props: ['title', 'subtitle', 'price', 'image', 'active'],

    methods: {
        moneyFormat(value) {
            return moneyFormat(value);
            // return parseFloat(value).toString().replace('.', ',') + '€';
        },

        onClick() {
            this.$emit('click');
        }
    }
};
</script>
